import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { AddInsuranceComponent } from './components/add-insurance/add-insurance.component';
import { AddProviderComponent } from './components/add-provider/add-provider.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { CompanyAddressComponent } from './components/company-address/company-address.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { CompanyRegulatorComponent } from './components/company-regulator/company-regulator.component';
import { CredentialsComponent } from './components/credentials/credentials.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { InsuranceListingComponent } from './components/insurance-listing/insurance-listing.component';
import { ProviderListingComponent } from './components/provider-listing/provider-listing.component';
import { ProvRegulatorComponent } from './components/prov-regulator/prov-regulator.component';
import { ProvDetailsComponent } from './components/prov-details/prov-details.component';
import { ProvAddressComponent } from './components/prov-address/prov-address.component';
import { ProvContactComponent } from './components/prov-contact/prov-contact.component';
import { ProvViewComponent } from './components/prov-view/prov-view.component';
import { PayerViewComponent } from './components/payer-view/payer-view.component';
import { PayerCapIntegrationComponent } from './components/payer-cap-integration/payer-cap-integration.component';
// import { ThirdPartyCompanyComponent } from './components/third-party-company/third-party-company.component';


const routes: Routes = [
  { path:'', component: DashboardComponent, 
  },
  ]
@NgModule({
  declarations: [
    DashboardComponent,
    AddInsuranceComponent,
    AddProviderComponent,
    CompanyDetailsComponent,
    CompanyAddressComponent,
    ContactDetailsComponent,
    CompanyRegulatorComponent,
    CredentialsComponent,
    InsuranceListingComponent,
    ProviderListingComponent,
    ProvRegulatorComponent,
    ProvDetailsComponent,
    ProvAddressComponent,
    ProvContactComponent,
    ProvViewComponent,
    PayerViewComponent,
    PayerCapIntegrationComponent,
   // ThirdPartyCompanyComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
		ReactiveFormsModule,
    SharedModule
  ],
  exports:[
    DashboardComponent
  ]
})
export class ProviderORinsuranceModule { }
